export default "__VITE_ASSET__qRCtsO6Y__"